/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueuedEvent } from '../../models/queued-event';
import { QueuedEventPatch } from '../../models/queued-event-patch';

export interface UpdateQueuedEvent$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: QueuedEventPatch
}

export function updateQueuedEvent(http: HttpClient, rootUrl: string, params: UpdateQueuedEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<QueuedEvent>> {
  const rb = new RequestBuilder(rootUrl, updateQueuedEvent.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueuedEvent>;
    })
  );
}

updateQueuedEvent.PATH = '/api/v1/queued_events/{id}';
